export type SeedChatMessage = {
  author: string;
  text: string;
  avatar: string;
  timestamp?: number;
};

export const DEFAULT_CHAT_STARTER: SeedChatMessage[] = [
  { author: "RK89", text: "Sanctions take forever to kick in lol", avatar: "RK" },
  {
    author: "ErikM",
    text: "@RK89 yeah, surprised more people aren't talking about the LNG stuff tbh.",
    avatar: "EM",
  },
  { author: "SaraG", text: "Any numbers on how many refugees Europe took in?", avatar: "SG" },
  {
    author: "LeoV",
    text: "I get why US has global focus, but sometimes feels like Europe handles more here??",
    avatar: "LV",
  },
  { author: "M_Santos", text: "Unicorns staying private is wild tbh.", avatar: "MS" },
  { author: "averylilia", text: "Lesotho for shirts? Didn't see that coming.", avatar: "AL" },
  { author: "Producer", text: "Everything ready for the next segment!", avatar: "PR" },
];
